export const insuranceCategory = {
  1: {
    label: '出境险',
    children: {
      1: '港澳台',
      2: '日韩',
      3: '东南亚',
      4: '英美澳加',
      5: '南美',
      6: '申根',
      7: '全球',
    },
  },
  2: {
    label: '拒签险',
    children: {
      1: '申根',
      2: '美新英澳爱',
      3: '加拿大',
      4: '其他',
    },
  },
  3: {
    label: '国内旅游险',
    children: [
    ],
  },
  4: {
    label: '人身意外险',
    children: {
      1: '航空意外险',
      2: '交通意外险',
      3: '人身意外险',
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/insurance-constants.js